import {
    FETCH_TRAINING_STATUS_AGGREGATED_DATA,
    FETCH_TRAINING_STATUS_AGGREGATED_DATA_FETCHING,
    FETCH_TRAINING_STATUS_AGGREGATED_DATA_SUCCESS,
    FETCH_TRAINING_STATUS_AGGREGATED_DATA_FAIL,
    FETCH_TRAINING_STATUS_MOST_RECENT_DATA,
    FETCH_TRAINING_STATUS_MOST_RECENT_DATA_FETCHING,
    FETCH_TRAINING_STATUS_MOST_RECENT_DATA_SUCCESS,
    FETCH_TRAINING_STATUS_MOST_RECENT_DATA_FAIL
} from '../../actions/ActionTypes.js';

const INITIAL_STATE = {
    payload: {},
    trainingStatusAggregatedData: {},
    trainingStatusMostRecentData: {},
    isFetching: false,
    fetchFailed: false
};

const fetchTrainingStatusAggregatedDataFetching = (state) => {
    return {
        ...state,
        isFetching: true,
        fetchFailed: false
    };
};

const fetchTrainingStatusAggregatedDataSuccess = (state, action) => {
    return {
        payload: action.trainingStatusDaily,
        trainingStatusAggregatedData: {
            ...state.trainingStatusAggregatedData,
            [action.userProfileId]: {
                ...state.trainingStatusAggregatedData[action.userProfileId],
                [action.calendarDate]: action.trainingStatusDaily
            }
        },
        isFetching: false,
        fetchFailed: false
    };
};

const fetchTrainingStatusAggregatedDataFail = (state, action) => {
    return {
        payload: action.trainingStatusDaily,
        trainingStatusAggregatedData: {
            ...state.trainingStatusAggregatedData,
            [action.userProfileId]: {
                ...state.trainingStatusAggregatedData[action.userProfileId],
                [action.calendarDate]: {}
            }
        },
        isFetching: false,
        fetchFailed: true
    };
};

const fetchTrainingStatusMostRecentDataFetching = (state) => {
    return {
        ...state,
        isFetching: true,
        fetchFailed: false
    };
};

const fetchTrainingStatusMostRecentDataSuccess = (state, action) => {
    return {
        payload: action.trainingStatusDaily,
        trainingStatusMostRecentData: {
            ...state.trainingStatusMostRecentData,
            [action.userProfileId]: {
                ...state.trainingStatusMostRecentData[action.userProfileId],
                [action.calendarDate]: action.trainingStatusDaily
            }
        },
        isFetching: false,
        fetchFailed: false
    };
};

const fetchTrainingStatusMostRecentDataFail = (state, action) => {
    return {
        payload: action.trainingStatusDaily,
        trainingStatusMostRecentData: {
            ...state.trainingStatusMostRecentData,
            [action.userProfileId]: {
                ...state.trainingStatusMostRecentData[action.userProfileId],
                [action.calendarDate]: {}
            }
        },
        isFetching: false,
        fetchFailed: true
    };
};

const handlers = {
    [FETCH_TRAINING_STATUS_AGGREGATED_DATA_FETCHING]: fetchTrainingStatusAggregatedDataFetching,
    [FETCH_TRAINING_STATUS_AGGREGATED_DATA_SUCCESS]: fetchTrainingStatusAggregatedDataSuccess,
    [FETCH_TRAINING_STATUS_AGGREGATED_DATA_FAIL]: fetchTrainingStatusAggregatedDataFail,
    [FETCH_TRAINING_STATUS_MOST_RECENT_DATA_FETCHING]: fetchTrainingStatusMostRecentDataFetching,
    [FETCH_TRAINING_STATUS_MOST_RECENT_DATA_SUCCESS]: fetchTrainingStatusMostRecentDataSuccess,
    [FETCH_TRAINING_STATUS_MOST_RECENT_DATA_FAIL]: fetchTrainingStatusMostRecentDataFail
};

export default function trainingStatusDaily(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// Actions
export function fetchTrainingStatusAggregatedData(userProfileId, calendarDate, evictCache) {
    return {
        type: FETCH_TRAINING_STATUS_AGGREGATED_DATA,
        calendarDate,
        userProfileId,
        meta: {
            cacheTime: evictCache ? null : 120000
        }
    };
}

export const getTrainingStatusAggregatedData = (state, userProfileId, calendarDate) => {
    return state.trainingStatusDaily.trainingStatusAggregatedData[userProfileId]
        ? state.trainingStatusDaily.trainingStatusAggregatedData[userProfileId][calendarDate]
        : null;
};

export const isTrainingStatusAggregatedDataFetching = (state) => {
    return state.trainingStatusDaily.isFetching;
};

export const didTrainingStatusAggregatedDataFetchFail = (state) => {
    return state.trainingStatusDaily.fetchFailed;
};

export function fetchTrainingStatusMostRecentData(userProfileId, calendarDate, evictCache) {
    return {
        type: FETCH_TRAINING_STATUS_MOST_RECENT_DATA,
        calendarDate,
        userProfileId,
        meta: {
            cacheTime: evictCache ? null : 1000
        }
    };
}

export const getTrainingStatusMostRecentData = (state, userProfileId, calendarDate) => {
    return state.trainingStatusDaily.trainingStatusMostRecentData[userProfileId]
        ? state.trainingStatusDaily.trainingStatusMostRecentData[userProfileId][calendarDate]
        : null;
};

export const isTrainingStatusMostRecentDataFetching = (state) => {
    return state.trainingStatusDaily.isFetching;
};

export const didTrainingStatusMostRecentDataFetchFail = (state) => {
    return state.trainingStatusDaily.fetchFailed;
};
